import { defineMessages } from 'react-intl';

const messages = defineMessages({
  home: {
    id: 'router.breadcrumbs.home',
    defaultMessage: 'Home',
  },
  title: {
    id: 'router.breadcrumbs.title',
    defaultMessage: 'Breadcrumbs',
  },
});

export default messages;
